const suits = [
  {
    cnj: "6239861-83.2022.1.00.0602",
    nome_autor: "Pérola Faria",
    nome_reu: "Ashton Kutcher",
    tribunal_origem: "TJSP",
    data_inicio: "17/01/2022",
    movimentacoes: [
      {
        data: "30/07/2022",
        descricao: "Proferido despacho de mero expediente",
      },
      {
        data: "10/08/2022",
        descricao: "Conclusos para despacho.",
      },
    ],
    detalhes_processo: [
      {
        descricao:
          "Duis dui magna, venenatis a tempus rhoncus, bibendum vel metus. Nam congue, arcu vitae consectetur consequat, ante ante ultricies magna, sed facilisis neque sapien non sem. Vestibulum lectus felis, sagittis sit amet risus in, accumsan lobortis velit.",
      },
      {
        descricao:
          "Nullam facilisis sagittis aliquam. Proin justo dolor, dictum a mollis vitae, pellentesque vitae arcu. Nullam lacinia, erat et elementum venenatis, ex dui tincidunt sem, non blandit est mauris nec quam. ",
      },
      {
        descricao:
          "Praesent ut malesuada nulla. Maecenas vitae leo ex. Phasellus a fringilla neque. Aliquam ut enim et urna mattis ullamcorper a id nisi.",
      },
    ],
    partes_envolvidas: [
      {
        nome: "Taylor Swift",
        parte_envolvida: "Apelante",
      },
      {
        nome: "Oswaldo Montenegro",
        parte_envolvida: "Advogado",
      },
      {
        nome: "Roberto Carlos",
        parte_envolvida: "Advogado",
      },
    ],
  },
  {
    cnj: "2669832-72.2022.1.00.0164",
    nome_autor: "Ana Souza",
    nome_reu: "Aline Jaconis",
    tribunal_origem: "TJSP",
    data_inicio: "17/01/2022",
    movimentacoes: [
      {
        data: "30/07/2022",
        descricao:
          "Cras pharetra rutrum quam eu aliquam. Praesent rhoncus lacus sit amet nunc dictum, eu ornare arcu vulputate. Suspendisse potenti. Nunc imperdiet facilisis ex id laoreet. Curabitur a est a eros cursus posuere",
      },
      {
        data: "10/08/2022",
        descricao:
          "Quisque nec rutrum ipsum, nec volutpat lorem. Donec sed interdum risus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.",
      },
    ],
    detalhes_processo: [
      {
        descricao:
          "Duis dui magna, venenatis a tempus rhoncus, bibendum vel metus. Nam congue, arcu vitae consectetur consequat, ante ante ultricies magna, sed facilisis neque sapien non sem. Vestibulum lectus felis, sagittis sit amet risus in, accumsan lobortis velit.",
      },
      {
        descricao:
          "Nullam facilisis sagittis aliquam. Proin justo dolor, dictum a mollis vitae, pellentesque vitae arcu. Nullam lacinia, erat et elementum venenatis, ex dui tincidunt sem, non blandit est mauris nec quam. ",
      },
      {
        descricao:
          "Praesent ut malesuada nulla. Maecenas vitae leo ex. Phasellus a fringilla neque. Aliquam ut enim et urna mattis ullamcorper a id nisi.",
      },
    ],
    partes_envolvidas: [
      {
        nome: "Ana Spencer",
        parte_envolvida: "Apelante",
      },
      {
        nome: "Alan Campos",
        parte_envolvida: "Advogado",
      },
      {
        nome: "Bruno Silva",
        parte_envolvida: "Advogado",
      },
    ],
  },
  {
    cnj: "0842492-57.2022.1.00.8005",
    nome_autor: "Simome Kardashian",
    nome_reu: "Eliza Kuster",
    tribunal_origem: "TJSP",
    data_inicio: "17/01/2022",
    movimentacoes: [
      {
        data: "30/07/2022",
        descricao:
          "Cras pharetra rutrum quam eu aliquam. Praesent rhoncus lacus sit amet nunc dictum, eu ornare arcu vulputate. Suspendisse potenti. Nunc imperdiet facilisis ex id laoreet. Curabitur a est a eros cursus posuere",
      },
      {
        data: "10/08/2022",
        descricao:
          "Quisque nec rutrum ipsum, nec volutpat lorem. Donec sed interdum risus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.",
      },
    ],
    detalhes_processo: [
      {
        descricao:
          "Duis dui magna, venenatis a tempus rhoncus, bibendum vel metus. Nam congue, arcu vitae consectetur consequat, ante ante ultricies magna, sed facilisis neque sapien non sem. Vestibulum lectus felis, sagittis sit amet risus in, accumsan lobortis velit.",
      },
      {
        descricao:
          "Nullam facilisis sagittis aliquam. Proin justo dolor, dictum a mollis vitae, pellentesque vitae arcu. Nullam lacinia, erat et elementum venenatis, ex dui tincidunt sem, non blandit est mauris nec quam. ",
      },
      {
        descricao:
          "Praesent ut malesuada nulla. Maecenas vitae leo ex. Phasellus a fringilla neque. Aliquam ut enim et urna mattis ullamcorper a id nisi.",
      },
    ],
    partes_envolvidas: [
      {
        nome: "Taylor Swift",
        parte_envolvida: "Apelante",
      },
      {
        nome: "Oswaldo Montenegro",
        parte_envolvida: "Advogado",
      },
      {
        nome: "Roberto Carlos",
        parte_envolvida: "Advogado",
      },
    ],
  },
  {
    cnj: "9358052-95.2022.1.00.1714",
    nome_autor: "Fernanda Sousa",
    nome_reu: "Spencer Richard",
    tribunal_origem: "TJSP",
    data_inicio: "17/01/2022",
    movimentacoes: [
      {
        data: "30/07/2022",
        descricao:
          "Cras pharetra rutrum quam eu aliquam. Praesent rhoncus lacus sit amet nunc dictum, eu ornare arcu vulputate. Suspendisse potenti. Nunc imperdiet facilisis ex id laoreet. Curabitur a est a eros cursus posuere",
      },
      {
        data: "10/08/2022",
        descricao:
          "Quisque nec rutrum ipsum, nec volutpat lorem. Donec sed interdum risus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.",
      },
    ],
    detalhes_processo: [
      {
        descricao:
          "Duis dui magna, venenatis a tempus rhoncus, bibendum vel metus. Nam congue, arcu vitae consectetur consequat, ante ante ultricies magna, sed facilisis neque sapien non sem. Vestibulum lectus felis, sagittis sit amet risus in, accumsan lobortis velit.",
      },
      {
        descricao:
          "Nullam facilisis sagittis aliquam. Proin justo dolor, dictum a mollis vitae, pellentesque vitae arcu. Nullam lacinia, erat et elementum venenatis, ex dui tincidunt sem, non blandit est mauris nec quam. ",
      },
      {
        descricao:
          "Praesent ut malesuada nulla. Maecenas vitae leo ex. Phasellus a fringilla neque. Aliquam ut enim et urna mattis ullamcorper a id nisi.",
      },
    ],
    partes_envolvidas: [
      {
        nome: "Taylor Swift",
        parte_envolvida: "Apelante",
      },
      {
        nome: "Oswaldo Montenegro",
        parte_envolvida: "Advogado",
      },
      {
        nome: "Roberto Carlos",
        parte_envolvida: "Advogado",
      },
    ],
  },
  {
    cnj: "7157839-52.2022.1.00.6647",
    nome_autor: "Márcio Granado",
    nome_reu: "Plinio Peloso",
    tribunal_origem: "TJSP",
    data_inicio: "17/01/2022",
    movimentacoes: [
      {
        data: "30/07/2022",
        descricao:
          "Cras pharetra rutrum quam eu aliquam. Praesent rhoncus lacus sit amet nunc dictum, eu ornare arcu vulputate. Suspendisse potenti. Nunc imperdiet facilisis ex id laoreet. Curabitur a est a eros cursus posuere",
      },
      {
        data: "10/08/2022",
        descricao:
          "Quisque nec rutrum ipsum, nec volutpat lorem. Donec sed interdum risus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.",
      },
    ],
    detalhes_processo: [
      {
        descricao:
          "Duis dui magna, venenatis a tempus rhoncus, bibendum vel metus. Nam congue, arcu vitae consectetur consequat, ante ante ultricies magna, sed facilisis neque sapien non sem. Vestibulum lectus felis, sagittis sit amet risus in, accumsan lobortis velit.",
      },
      {
        descricao:
          "Nullam facilisis sagittis aliquam. Proin justo dolor, dictum a mollis vitae, pellentesque vitae arcu. Nullam lacinia, erat et elementum venenatis, ex dui tincidunt sem, non blandit est mauris nec quam. ",
      },
      {
        descricao:
          "Praesent ut malesuada nulla. Maecenas vitae leo ex. Phasellus a fringilla neque. Aliquam ut enim et urna mattis ullamcorper a id nisi.",
      },
    ],
    partes_envolvidas: [
      {
        nome: "Taylor Swift",
        parte_envolvida: "Apelante",
      },
      {
        nome: "Oswaldo Montenegro",
        parte_envolvida: "Advogado",
      },
      {
        nome: "Roberto Carlos",
        parte_envolvida: "Advogado",
      },
    ],
  },
  {
    cnj: "4038561-07.2022.1.00.0893",
    nome_autor: "Simone Maria",
    nome_reu: "Ross Geller",
    tribunal_origem: "TJSP",
    data_inicio: "17/01/2022",
    movimentacoes: [
      {
        data: "30/07/2022",
        descricao:
          "Cras pharetra rutrum quam eu aliquam. Praesent rhoncus lacus sit amet nunc dictum, eu ornare arcu vulputate. Suspendisse potenti. Nunc imperdiet facilisis ex id laoreet. Curabitur a est a eros cursus posuere",
      },
      {
        data: "10/08/2022",
        descricao:
          "Quisque nec rutrum ipsum, nec volutpat lorem. Donec sed interdum risus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.",
      },
    ],
    detalhes_processo: [
      {
        descricao:
          "Duis dui magna, venenatis a tempus rhoncus, bibendum vel metus. Nam congue, arcu vitae consectetur consequat, ante ante ultricies magna, sed facilisis neque sapien non sem. Vestibulum lectus felis, sagittis sit amet risus in, accumsan lobortis velit.",
      },
      {
        descricao:
          "Nullam facilisis sagittis aliquam. Proin justo dolor, dictum a mollis vitae, pellentesque vitae arcu. Nullam lacinia, erat et elementum venenatis, ex dui tincidunt sem, non blandit est mauris nec quam. ",
      },
      {
        descricao:
          "Praesent ut malesuada nulla. Maecenas vitae leo ex. Phasellus a fringilla neque. Aliquam ut enim et urna mattis ullamcorper a id nisi.",
      },
    ],
    partes_envolvidas: [
      {
        nome: "Taylor Swift",
        parte_envolvida: "Apelante",
      },
      {
        nome: "Oswaldo Montenegro",
        parte_envolvida: "Advogado",
      },
      {
        nome: "Roberto Carlos",
        parte_envolvida: "Advogado",
      },
    ],
  },
];

export default suits;
